import { Language } from "./Language";

export * from "./Language";

export default Language;
